<div class="mt-5 pt-5 mx-3">
  <div class="row articale-card" *ngFor="let item of articles.services">    
    
          <div class="col-2">
            <a [href]="articles.isDetails ? getLink(item) : null" style="text-decoration: none">
            <h4 class="category">Article</h4>
            </a>
          </div>
          <div class="col-8">
            <a [href]="articles.isDetails ? getLink(item) : null" style="text-decoration: none">
            <h4 class="title">
              {{item.title}}
            </h4>
            <h6 class="description">
              {{item.summary}}
            </h6>
          </a>
          </div>
          <div class="col-2">
            <a [href]="articles.isDetails ? getLink(item) : null" style="text-decoration: none">
            <img
              class="w-100"
              src="../../../assets/template/media/homeComponents/software-services/genai-agency-it-consulting.jpg"
            />
          </a>
          </div>    
  </div>
</div>
